import React from 'react';
import './ProcessSteps.scss';

/**
 * Numbered, vertically-connected step list used by the funnel's "how it works" sections
 * (Figma nodes 568:456 and 2933:568). Each step is a dark numbered circle plus a title and
 * description, joined by a continuous connector line.
 *
 * @param {Array<{title: string, description: string}>} steps Ordered list of steps.
 */
const ProcessSteps = ({ steps }) => (
  <ol className="process-steps">
    {steps.map((step, index) => (
      <li className="process-steps__row" key={step.title}>
        <span className="process-steps__number">{index + 1}</span>
        <span className="process-steps__txt">
          <span className="process-steps__title">{step.title}</span>
          <span className="process-steps__description">{step.description}</span>
        </span>
      </li>
    ))}
  </ol>
);

export default ProcessSteps;
